import script from "./PLC.vue?vue&type=script&setup=true&lang=js"
export * from "./PLC.vue?vue&type=script&setup=true&lang=js"

import "./PLC.vue?vue&type=style&index=0&id=50ad491d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50ad491d"]])

export default __exports__